"use client";

import { cn } from "@/lib/utils";
import { useSaleCountdown } from "@/lib/sale";
import { SALE_LABEL, type PassPlan } from "@/components/pricing/planContent";

/**
 * Sale banner above the plan chooser, counting down to the end of the sale.
 * The days-to-sitting framing belongs to the sale announcement instead, so the
 * two surfaces answer different questions. Hidden when nothing is discounted.
 */
export function SaleBanner({ plans, className }: { plans: PassPlan[]; className?: string }) {
  const { days, expired, ready } = useSaleCountdown();

  const lifetime = plans.find((p) => p.id === "pass_lifetime");
  if (!lifetime?.originalAmount || lifetime.originalAmount <= lifetime.amount) return null;
  if (expired) return null;

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-4 rounded-lg border border-primary/40 bg-primary/10 px-4 py-2.5",
        className,
      )}
    >
      <p className="text-sm font-semibold text-primary">{SALE_LABEL}</p>
      {ready ? (
        <p className="shrink-0 text-sm text-foreground/80">
          {days > 0 ? (
            <>
              Ends in{" "}
              <span className="font-bold tabular-nums text-primary">
                {days} {days === 1 ? "day" : "days"}
              </span>
            </>
          ) : (
            <span className="font-bold text-primary">Ends today</span>
          )}
        </p>
      ) : null}
    </div>
  );
}
